import * as React from "react";
import { Helmet } from "react-helmet-async";

import { cn } from "@/lib/utils";

/*
 * shadcn-flavoured equivalent of the existing MUI `<Page>` + `<Container>`
 * combination so new pages slot into DashboardLayout's outlet with the
 * same outer chrome. Pairs with PageHeader / Breadcrumbs.
 */

interface PageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Document title segment. Suffixed with "| Betterfield" to match the
   * legacy MUI Page component.
   */
  title?: string;
  /** Extra <head> nodes (meta, links, etc.). */
  meta?: React.ReactNode;
}

export function PageContainer({
  title,
  meta,
  className,
  children,
  ...props
}: PageContainerProps) {
  return (
    <>
      <Helmet>
        <title>{title ? `${title} | Betterfield` : "Betterfield"}</title>
        {meta}
      </Helmet>
      <div
        className={cn(
          "mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8",
          className,
        )}
        {...props}
      >
        {children}
      </div>
    </>
  );
}
